import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=575f9b4b&isComponent&outputPath=components%2Findex580e16a0%2Findex"
import script from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex580e16a0%2Findex"
export * from "./index.mpx?vue&type=script&lang=ts&isComponent&outputPath=components%2Findex580e16a0%2Findex"
import style0 from "./index.mpx?vue&type=style&index=0&id=575f9b4b&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_580e16a0%22%7D&isComponent&outputPath=components%2Findex580e16a0%2Findex"


/* normalize component */
import normalizer from "!../../../../../example/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports